<section class="projects-showcase" id="projects">
  <div class="projects-showcase__pin">
    <div class="project-pill">
      <div
        class="project-pill__left"
        [class.project-pill__left--animate]="pillAnimate">
        <div class="project-pill__icon">
          <img [src]="activeShowcaseProject().logo" alt="">
        </div>

        <div class="project-pill__text">
          <span>{{ activeShowcaseProject().title }}</span>
          <small>{{ activeShowcaseProject().category }}</small>
        </div>
      </div>

      <a
        class="project-pill__button"
        [routerLink]="['/projects', activeShowcaseProject().slug, 'title']">
        See case
      </a>
    </div>
  </div>

  <section class="project-screen project-screen--dark"></section>
  <section class="project-screen project-screen--gray"></section>
  <section class="project-screen project-screen--light"></section>
</section>
